import { SchemaDefinition } from "../validator/schema-definition-interface";

/**
 * The schema definition for the stored date part object.
 */
export const storedDatePartSchema: SchemaDefinition = {
	Name: 'stored-date-part',
	Properties: {
		Year: { Type: 'number' },
		Month: { Type: 'number' },
		Day: { Type: 'number' }
	}
}